<!--
 * @Author: 仙道
 * @Date: 2022-12-11 18:35:20
 * @LastEditTime: 2022-12-12 00:11:27
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/report/online/modules/ReportTabs.vue
-->
<template>
  <div>
    <a-tabs @change="tabsChange" v-model="activeCode" v-show="false">
      <a-tab-pane :key="tabs.code" :tab="tabs.name" v-for="(tabs,key) in reportTabs"></a-tab-pane>
    </a-tabs>
    <div class="report-container" v-if="activeCode&&reportType!==''">
      <template v-show="reportType">
        <IframeView
          :key="tabs.code"
          :url="tabs.view"
          v-for="(tabs,key) in reportTabs.filter(item=>item.isIframe)"
          v-show="activeCode===tabs.code"
        />
      </template>
      <template v-show="!reportType">
          <component
            v-show="activeCode===tabs.code"
            :is="tabs.component"
            :key="tabs.code"
            v-for="(tabs,key) in reportTabs.filter(item=>!item.isIframe)"
          ></component>
        </keep-alive>
      </template>
    </div>
 
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import IframeView from '@/components/layouts/iframeReportView.vue'
  export default {
    name: 'ReportTabs',
    components: {
      IframeView
    },
    // 定义属性
    data () {
      return {
        aa: '111',
        activeCode: ''
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['reportTabs', 'tabActiveCode']),
      reportType () {
        const isIframe = this.reportTabs.find(item => item.code == this.activeCode)?.isIframe ?? ''
        return isIframe
      }
    },
    // 监控data中的数据变化
    watch: {
      "tabActiveCode": {
        immediate: true,
        handler (val) {

          this.activeCode = val
        }
      },
      // "reportType": {
      //   immediate: true,
      //   handler (val) {
      //     this.reportTabs.filter(item => item.code == this.tabActiveCode)
      //   }
      // }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      tabsChange (v) {

        this.$store.commit('UPDATE_ACTIVE_TAB_CODE', v)
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>